import React from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as HomeIcon } from '../assets/images/icons/home1.svg';
// import { ReactComponent as UserIcon } from '../assets/images/icons/user.svg';
import { ReactComponent as UserIcon } from '../assets/images/icons/people.svg';
import { ReactComponent as SettingIcon } from '../assets/images/icons/gear.svg';
import { ReactComponent as ViewDataIcon } from '../assets/images/icons/view.svg';
import {ReactComponent as MandatoryInfoIcon} from '../assets/images/icons/kanban.svg';
import {ReactComponent as InfoIcon} from '../assets/images/icons/info-square.svg';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = ({ isOpen }) => {
  const { userDetails } = useAuth();
  const isAdmin = userDetails?.admin === true;

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <ul className="sidebar-menu">
        <li>
          <NavLink to="/home" className="sidebar-link">
            <HomeIcon className="sidebar-icon" />
            {isOpen && <span>Home</span>}
          </NavLink>
        </li>
        <li>
          <NavLink to="/organization" className="sidebar-link">
            <MandatoryInfoIcon className="sidebar-icon" />
            {isOpen && <span className=''>Registry</span>}
          </NavLink>
        </li>
        {isAdmin && (
          <li>
            <NavLink to="/user" className="sidebar-link">
              <UserIcon className="sidebar-icon" />
              {isOpen && <span className=''>User</span>}
            </NavLink>
          </li>
        )}
        {/* <li>
          <NavLink to="/create-user" className="sidebar-link">
            <UserIcon className="sidebar-icon" />
            {isOpen && <span>Create User</span>}
          </NavLink>
        </li> */}
        <li>
          <NavLink to="/view-data" className="sidebar-link">
            <ViewDataIcon className="sidebar-icon" />
            {isOpen && <span className='mb-1'>View Data</span>}
          </NavLink>
        </li>
        {/* <li>
          <NavLink to="/mandatory-info" className="sidebar-link">
            <InfoIcon className="sidebar-icon" />
            {isOpen && <span className=''>Mandatory Info</span>}
          </NavLink>
        </li> */}
        <li>
          <NavLink to="/mandatory-info" className="sidebar-link">
            <SettingIcon className="sidebar-icon" />
            {isOpen && <span className='mb-1'>Settings</span>}
          </NavLink>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;